import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MozambiqueFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15558'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15558)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#FFE547'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#118C81'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2666H20V3.73328H0V10.2666Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='#EF2147'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.33408 7.89181L1.93459 8.88767L2.46856 7.27556L1.06966 6.27892L2.79916 6.27843L3.33408 4.66663L3.869 6.27843L5.5985 6.27892L4.19959 7.27556L4.73357 8.88767L3.33408 7.89181Z'
					fill='#FDE444'
				/>
			</g>
		</svg>
	);
};

export default MozambiqueFlagIcon;
